import { render, staticRenderFns } from "./BecaNivel.vue?vue&type=template&id=823d0f2e&scoped=true"
import script from "./BecaNivel.vue?vue&type=script&lang=js"
export * from "./BecaNivel.vue?vue&type=script&lang=js"
import style0 from "./BecaNivel.vue?vue&type=style&index=0&id=823d0f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823d0f2e",
  null
  
)

export default component.exports